import axios from "axios";

const getAdditionalInfoFields = async (companyId) => {
  try {
    const response = await axios.get(
      "/consumer/system-admin/api/v1/data-summary/additional-info-fields",
      {
        params: { company_id: companyId },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    const errorResponse = {
      success: false,
      error: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "ERROR_UNKNOWN",
      data: [],
      details: error.response?.data?.data || null,
    };
    console.error("API Error Details:", errorResponse);
    throw errorResponse;
  }
};

export default getAdditionalInfoFields;
